// extracted by mini-css-extract-plugin
export default {"infoBar":"Task_infoBar__+HOhi","collapseBtn":"Task_collapseBtn__nqjrN","hideFinishAlt":"Task_hideFinishAlt__eNomT","hideIt":"Task_hideIt__KMw+1","label":"Task_label__b+8Um"};